import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';

const NavBar = (props) => {

    return <div className="portalHeader">
        <Row>
            <Col md={4} sm={4} xs={4}>
                <div className={`headingToggle ${props.currentStep == 1 ? 'active' :'unActive'}`}>
                    <span>1</span>
                    <p>Check Eligibility</p>
                </div>
            </Col>
            <Col md={4} sm={4} xs={4}>
                <div className={`headingToggle ${props.currentStep == 2 ? 'active' :'unActive'}`}>
                    <span>2</span>
                    <p>Accept Offer & Onboarding</p>
                </div>
            </Col>
            <Col md={4} sm={4} xs={4}>
                <div className={`headingToggle ${props.currentStep == 4 ? 'active' :'unActive'}`}>
                    <span>3</span>
                    <p>Add challan</p>
                </div>
            </Col>
        </Row>
    </div>
}

export default NavBar;